import { FAUX_FACE_TYPE } from '../../../../constants/face';

export const isPubBoxFace = face =>
  face.faux_face_type === FAUX_FACE_TYPE.HAND_LABELED_PUB && face.is_creator;

export const PUB_BOX_COVERAGE_THRESHOLD = 0.9;

// Faceboxes are [x, y, width, height] in relative units. Returns how much of
// the covered box's area falls inside the covering box (0 to 1).
export const getFaceboxCoverage = (coveringFacebox, coveredFacebox) => {
  const [coveringX, coveringY, coveringWidth, coveringHeight] =
    coveringFacebox ?? [];
  const [coveredX, coveredY, coveredWidth, coveredHeight] =
    coveredFacebox ?? [];

  const coveredArea = coveredWidth * coveredHeight;

  if (!coveredArea) {
    return 0;
  }

  const overlapWidth = Math.max(
    0,
    Math.min(coveringX + coveringWidth, coveredX + coveredWidth) -
      Math.max(coveringX, coveredX),
  );
  const overlapHeight = Math.max(
    0,
    Math.min(coveringY + coveringHeight, coveredY + coveredHeight) -
      Math.max(coveringY, coveredY),
  );

  return (overlapWidth * overlapHeight) / coveredArea;
};

export const pubBoxCoversFacebox = (pubFacebox, naturalFacebox) =>
  getFaceboxCoverage(pubFacebox, naturalFacebox) > PUB_BOX_COVERAGE_THRESHOLD;
